import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import withLoader from 'components/organisms/withLoader';
import common from 'constants/common';
import { generateFullName } from 'utils/badgeHelpers';

const getCovidStatus = (status) => {
  if (status === common.covidStatuses.positive.status) {
    return true;
  }
  return false;
};

const checkIsInactive = (status) => status?.includes('inactive');
const checkIsOnboarding = (status) => status?.includes('onboarding');
const checkIsPendingReview = (status) => status?.includes('pending_review');

const PatientMobileCovidNameBadge = ({ profile, patientDetailsLoading }) => {
  const {
    birthDate,
    title,
    firstName,
    lastName,
    middleName,
    status,
    covidStatus,
  } = profile;
  const isInactive = useMemo(() => checkIsInactive(status), [status]);
  const isOnboarding = useMemo(() => checkIsOnboarding(status), [status]);
  const isPendingReview = useMemo(() => checkIsPendingReview(status), [status]);
  return (
    <div>
      {withLoader(
        patientDetailsLoading,
        <div className="mobile-name-badge">
          <>
            <div className="fullName">
              {generateFullName(title, firstName, middleName, lastName)}
            </div>
            <div className="birthDate">{birthDate?.replaceAll('-', '/')}</div>
            <div
              className={classnames(
                'status',
                { 'status--inactive': isInactive },
                { 'status--onboarding': isOnboarding },
                { 'status--pending-review': isPendingReview },
              )}
            />
            {getCovidStatus(covidStatus) && (
              <div className="covid">At-risk Covid</div>
            )}
          </>
        </div>,
      )}
    </div>
  );
};

PatientMobileCovidNameBadge.defaultProps = {
  patientDetailsLoading: false,
};

PatientMobileCovidNameBadge.propTypes = {
  profile: PropTypes.shape().isRequired,
  patientDetailsLoading: PropTypes.bool,
};

export default PatientMobileCovidNameBadge;
